/*
  Build-a-kit (product.build-a-kit template).
  Groups live in snippets/build-a-kit-groups.liquid (left column), the "Your kit" summary in
  snippets/build-a-kit-variant.liquid (buy column). assets/product-form.js adds every checked
  .addon-item .opt-btn with a variant id to the cart alongside the base product.
*/
(() => {
  if (document.documentElement.dataset.bakInitialized === 'true') return;
  const groups = Array.from(document.querySelectorAll('[data-bak-group]'));
  const summary = document.querySelector('[data-bak-summary]');
  if (!groups.length || !summary) return;
  document.documentElement.dataset.bakInitialized = 'true';

  const form = document.querySelector('form.js-product-form-main') || document.querySelector('form[action*="/cart/add"]');
  const submitButtons = [];
  if (form) {
    const inForm = form.querySelector('[name="add"]');
    if (inForm) submitButtons.push(inForm);
    document.querySelectorAll(`[form="${form.id}"][type="submit"]`).forEach((b) => submitButtons.push(b));
  }

  const subtotalEl = summary.querySelector('#build-a-kit-price');
  const linesEl = summary.querySelector('[data-bak-lines]');
  const emptyEl = summary.querySelector('[data-bak-empty]');
  const progressEl = summary.querySelector('[data-bak-progress]');
  const requiredNote = summary.querySelector('[data-bak-required-note]');
  const baseVariantEl = summary.querySelector('[data-bak-base-variant]');
  const basePriceEl = summary.querySelector('[data-bak-base-price]');
  const stickyTotals = document.querySelectorAll('[data-bak-sticky-total]');
  const isDesktop = () => window.matchMedia('(min-width: 769px)').matches;

  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const fmt = (cents) => money.format((cents || 0) / 100);
  const plus = (cents) => (cents > 0 ? `+ ${fmt(cents)}` : fmt(cents));

  const checkedIn = (group) => Array.from(group.querySelectorAll('.addon-item .opt-btn:checked'));
  const chosenIn = (group) => checkedIn(group).filter((i) => i.value && Number(i.value) > 0);
  const allChosen = () => groups.flatMap(chosenIn);

  function updateGroup(group) {
    const chosen = chosenIn(group);
    const selection = group.querySelector('[data-bak-selection]');
    const price = group.querySelector('[data-bak-group-price]');
    const required = group.dataset.required === 'true';
    const total = chosen.reduce((sum, i) => sum + (parseFloat(i.dataset.price) || 0), 0);
    if (selection) {
      if (!chosen.length) selection.textContent = required ? 'Select an option' : 'None';
      else if (chosen.length === 1) selection.textContent = chosen[0].dataset.label;
      else selection.textContent = `${chosen.length} items · ${chosen.map((i) => i.dataset.label).join(', ')}`;
    }
    if (price) price.textContent = total > 0 ? plus(total) : '';
    group.classList.toggle('bak-group--has-selection', chosen.length > 0);
  }

  function renderLines() {
    if (!linesEl) return;
    linesEl.querySelectorAll('[data-bak-line]').forEach((li) => li.remove());
    const chosen = allChosen();
    chosen.forEach((input) => {
      const li = document.createElement('li');
      li.className = 'bak-summary__line';
      li.dataset.bakLine = input.id;
      li.innerHTML = `<button type="button" class="bak-summary__remove" aria-label="Remove ${input.dataset.label}" data-bak-remove="${input.id}">&times;</button>`
        + `<span class="bak-summary__line-label">${input.dataset.label}</span>`
        + `<span class="bak-summary__line-price">${plus(parseFloat(input.dataset.price) || 0)}</span>`;
      linesEl.appendChild(li);
    });
    if (emptyEl) emptyEl.hidden = chosen.length > 0;
  }

  function updateSubtotal() {
    if (!subtotalEl) return;
    const base = parseFloat(subtotalEl.dataset.mainPrice) || 0;
    const addOns = allChosen().reduce((sum, i) => sum + (parseFloat(i.dataset.price) || 0), 0);
    const text = fmt(base + addOns);
    subtotalEl.textContent = text;
    stickyTotals.forEach((el) => { el.textContent = text; });
  }

  function updateProgress() {
    if (!progressEl) return;
    const done = groups.filter((g) => chosenIn(g).length > 0).length;
    const missing = groups.filter((g) => g.dataset.required === 'true' && chosenIn(g).length === 0).length;
    progressEl.textContent = `${done} of ${groups.length} groups chosen${missing ? ` · ${missing} required left` : ''}`;
  }

  function setBlocked(blocked) {
    submitButtons.forEach((btn) => {
      if (blocked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.bakDisabled = 'true';
      } else if (btn.dataset.bakDisabled === 'true') {
        btn.removeAttribute('aria-disabled');
        delete btn.dataset.bakDisabled;
      }
    });
  }

  function validate() {
    const missing = groups.filter((g) => g.dataset.required === 'true' && chosenIn(g).length === 0);
    groups.forEach((g) => g.classList.toggle('bak-group--missing', missing.includes(g)));
    if (requiredNote) requiredNote.hidden = missing.length === 0;
    setBlocked(missing.length > 0);
    return missing;
  }

  function refresh() {
    groups.forEach(updateGroup);
    renderLines();
    updateSubtotal();
    updateProgress();
    validate();
  }

  // Selections
  groups.forEach((group) => {
    group.querySelectorAll('.addon-item .opt-btn').forEach((input) => input.addEventListener('change', refresh));
    const showAll = group.querySelector('[data-bak-show-all]');
    if (showAll) {
      showAll.addEventListener('click', () => {
        const expanded = group.classList.toggle('bak-group--expanded');
        showAll.textContent = expanded ? showAll.dataset.lessText : showAll.dataset.moreText;
      });
    }
    // Mobile: one group open at a time
    group.addEventListener('toggle', () => {
      if (!group.open || isDesktop()) return;
      groups.forEach((other) => { if (other !== group) other.open = false; });
    });
  });

  // Mobile: start with required groups open, the rest closed
  if (!isDesktop()) {
    groups.forEach((g, i) => { g.open = g.dataset.required === 'true' || (i === 0 && !groups.some((x) => x.dataset.required === 'true')); });
  }

  // Remove from the summary
  summary.addEventListener('click', (evt) => {
    const btn = evt.target.closest('[data-bak-remove]');
    if (!btn) return;
    const input = document.getElementById(btn.dataset.bakRemove);
    if (!input) return;
    if (input.type === 'radio') {
      const none = input.closest('[data-bak-group]')?.querySelector('.addon-item--none .opt-btn');
      if (none) none.checked = true; else input.checked = false;
    } else {
      input.checked = false;
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Base variant changes (Step 1 pills)
  document.addEventListener('on:variant:change', (evt) => {
    const variant = evt.detail && evt.detail.variant;
    if (!variant || !subtotalEl) return;
    subtotalEl.dataset.mainPrice = variant.price;
    if (basePriceEl) basePriceEl.textContent = fmt(variant.price);
    if (baseVariantEl && variant.title) baseVariantEl.textContent = variant.title;
    updateSubtotal();
  });

  // Details drawers
  const closeModals = () => {
    document.querySelectorAll('.bak-modal:not([hidden])').forEach((m) => { m.hidden = true; });
    document.documentElement.classList.remove('bak-modal-open');
    document.body.classList.remove('bak-modal-open');
  };
  document.querySelectorAll('[data-bak-modal-open]').forEach((button) => {
    button.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      const modal = document.getElementById(button.dataset.bakModalOpen);
      if (!modal) return;
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      modal.hidden = false;
      document.documentElement.classList.add('bak-modal-open');
      document.body.classList.add('bak-modal-open');
    });
  });
  document.querySelectorAll('[data-bak-modal-close]').forEach((el) => el.addEventListener('click', closeModals));
  document.addEventListener('keydown', (evt) => { if (evt.key === 'Escape') closeModals(); });
  document.querySelectorAll('[data-bak-select]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.getElementById(`bak-option-${button.dataset.bakSelect}`);
      if (!input || input.disabled) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // Block add-to-cart until required groups are chosen
  const guard = (evt) => {
    const missing = validate();
    if (!missing.length) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    missing[0].open = true;
    missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  submitButtons.forEach((btn) => btn.addEventListener('click', guard, true));
  if (form) form.addEventListener('submit', guard, true);

  refresh();
})();
